import InvitePersonForm from './InvitePersonForm';

export default InvitePersonForm;
